import { render, staticRenderFns } from "./PublicationFiltersTab.vue?vue&type=template&id=21322ab8&"
import script from "./PublicationFiltersTab.vue?vue&type=script&lang=js&"
export * from "./PublicationFiltersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports